<template>
  <div class="modal-overflow">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <h6 style="padding-top:18px">Tag</h6>
          <div style="margin-top:18px;">
            <el-input type="text"
                  name="tag"
                  placeholder="Tag"
                  ref="tag"
                  clearable
                  :disabled="!canEdit"
                  v-validate="'required'"
                  v-model="edit.name" />
            <small class="text-danger" v-show="errors.has('tag')">
              {{ getError('tag') }}
            </small>
          </div>
          <div style="margin-top:18px;">
            <el-select class="select"
                        name="projectType"
                        size="large"
                        data-vv-as="project type"
                        placeholder="Project Type"
                        v-validate="'required'"
                        clearable
                        v-model="edit.projectType">
              <el-option v-for="option in projectTypes"
                          class="select"
                          :value="option.value"
                          :label="option.label"
                          :key="option.label">
              </el-option>
            </el-select>
            <small class="text-danger" v-show="errors.has('projectType')">
              {{ getError('projectType') }}
            </small>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="margin-top: 15px" v-if="canEdit">
      <div class="col-md-12">
        <button
          type="button"
          :disabled="isSubmitDisabled"
          @click="validateAndSubmit"
          class="btn btn-fill btn-info btn-wd pull-right">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    notifySuccess,
    notifyError
  } from 'src/utilities/utils'
  import Constants from 'src/utilities/constants'
  import Permissions from 'src/utilities/permissions'
  import PButton from 'src/components/UIComponents/Button.vue'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import {sync} from 'vuex-pathify'
  import {mapGetters} from 'vuex'
  import {OK} from 'http-status-codes'

  export default {
    props: ['data'],
    components: {
      PButton,
      PSwitch
    },
    computed: {
      edit: sync('inspectorApp/tags@edit'),
      ...mapGetters({
        projectTypes: 'types/project'
      }),
      canEdit() {
        return this.$can('edit', Permissions.TAGS)
      },
      isSubmitDisabled() {
        return this.isProcessing
      }
    },
    data() {
      return {
        constants: Constants,
        isProcessing: false
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      async validateAndSubmit() {
        this.isProcessing = true

        if (await this.$validator.validateAll()) {
          if (this.$store.get('inspectorApp/tags/isDuplicateTag')) {
            notifyError(this, `A ${this.edit.name}, ${this.edit.projectType} tag already exists. Duplicate tags are not allowed.`)
            return
          }

          const payload = this.$store.get('inspectorApp/tags/savePayload', 'tags')
          const response = await this.$store.dispatch('save', payload)

          if (response.result === Constants.RETURN_CODES.SUCCESS) {
            this.$store.commit('inspectorApp/tags/resetEdit')
            this.$eventHub.$emit('inspectorAppTagSaved', response.data)
            this.$emit('close')
            notifySuccess(this, 'Tag Saved Successfully')
          } else if (response.result === Constants.RETURN_CODES.ERROR) {
            notifyError(this, 'Error Saving Tag', response.errors)
          }
        }
        this.isProcessing = false
      }
    },
    async beforeMount() {
      if (this.data && this.data.id) {
        const response = await this.$store.dispatch('fetchById', {
          endpoint: Constants.ENTITY_ENDPOINTS.TAGS,
          id: this.data.id
        })

        if (OK !== response.status) {
          notifyError(this, 'Failed to load Inspector App Tag')
          return
        }
        this.$store.commit('inspectorApp/tags/hydrateEdit', response.data)
      }
    },
    async mounted() {
      await this.$store.cache.dispatch('types/fetchByEntityType', 'Project')
      await this.$store.cache.dispatch('inspectorApp/tags/fetchAll')
      this.$refs.tag.focus()
    },
    destroyed() {
      this.$store.commit('inspectorApp/tags/resetEdit')
    }
  }
</script>

<style scoped>
  label {
    display: block;
  }
  .client-builder-row {
    border: 1px solid #ddd;
    padding: 0;
    margin: 0 0 5px 0;
    border-radius: 7px;
  }
</style>
